module.exports = __webpack_public_path__ + "static/media/dash.5eef22c9.svg";